module.exports = __webpack_public_path__ + "static/media/hero-ready2go.c910aa79.webp";